module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    attrs: {
      "id": "sigil_toc_id_2"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/foreward"
    }
  }, [_vm._v("Foreword")])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "first"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1#toc_marker-3"
    }
  }, [_vm._v("1 Facing Reality")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/ch1"
    }
  }, [_c('i', [_vm._v("The Grace of Acceptance")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2#toc_marker-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Experiencing the Presence")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch2",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Grace of Submission")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3#toc_marker-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Giving Up")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Grace of Relinquishment")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4#toc_marker-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Stuck in an Airport")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch4",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Grace of Compassion")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5#toc_marker-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 God Is Not Mad at You")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch5",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Grace of Trust")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6#toc_marker-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Wounded Healers")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch6",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Grace of Community")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7#toc_marker-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 A Cup of Cool Water")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch7",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Grace of Comfort")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8#toc_marker-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Life in the Slow Lane")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch8",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Grace of Simplicity")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9#toc_marker-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Possibilities")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch9",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Grace of Hope")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10#toc_marker-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Streams of Grace")])]), _vm._v(" "), _c('p', {
    staticClass: "body"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/ch10",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("The Grace of Living a New Way")])])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/acknowledgments",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/notes#toc_marker-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/praise#toc_marker-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Praise for "), _c('i', [_vm._v("The Way of Grace")])])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/authors",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/formatio",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Formatio")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/renovare",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("What is Renovaré?")])]), _vm._v(" "), _c('p', {
    staticClass: "firstleft"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/moreivp",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("More Titles from InterVarsity Press")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-78ee341a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/contents.vue
// module id = 66
// module chunks = 0